import { render } from "./AdminDashboardView.vue?vue&type=template&id=326f671d"
import script from "./AdminDashboardView.vue?vue&type=script&lang=js"
export * from "./AdminDashboardView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__